// extracted by mini-css-extract-plugin
export default {"policies":"policies___TBGuo","policy":"policy___vOpMp","title":"title___fAtBc","pre":"pre___XMtJV","empty":"empty___DzdJu","block":"block___gRMBu"};